const groupA = [
    {
        "value": "12783127",
        "label": "BULKDATAONE FHIRONE"
    },
    {
        "value": "12783128",
        "label": "BULKDATATWO FHIRTWO"
    },
    {
        "value": "12783129",
        "label": "BULKDATATHREE FHIRTHREE"
    },
    {
        "value": "12783130",
        "label": "BULKDATAFour FHIRFour"
    },
    {
        "value": "12783131",
        "label": "BULKDATAFive FHIRFive"
    },
    {
        "value": "12783132",
        "label": "BULKDATASix FHIRSix"
    },
    {
        "value": "12783133",
        "label": "BULKDATASeven FHIRSeven"
    },
    {
        "value": "12783134",
        "label": "BULKDATAEIGHTA FHIREIGHT"
    },
    {
        "value": "12783135",
        "label": "BULKDATANINE FHIRNINE"
    },
    {
        "value": "12783136",
        "label": "BULKDATATen FHIRTen"
    }
];


const groupB = [
    {
        "value": "12783127",
        "label": "BULKDATAONE FHIRONE B"
    },
    {
        "value": "12783128",
        "label": "BULKDATATWO FHIRTWO B"
    },
    {
        "value": "12783129",
        "label": "BULKDATATHREE FHIRTHREE B"
    }
];


const checkBoxesEpic = [
    "All",
    "AllergyIntolerance",
    "Appointment",
    "CarePlan",
    "CareTeam",
    "Condition",
    "Consent",
    "Device",
    "DiagnosticReport",
    "DocumentReference",
    "Encounter",
    "Goal",
    "Immunization",
    "List",
    "Location",
    "Medication",
    "MedicationRequest",
    "Observation",
    "Organization",
    "Patient",
    "Practitioner",
    "Procedure",
    "Provenance",
    "Provenance",
    "ServiceRequest",
    "Specimen"
]
const checkBoxesNextgen= [
    "All",
    "AllergyIntolerance",
    "CarePlan",
    "Condition",
    "DiagnosticReport",
    "DocumentReference",
    "Encounter",
    "Immunization",
    "Location",
    "Medication",
    "MedicationRequest",
    "Observation",
    "Organization",
    "Patient",
    "Practitioner",
    "Procedure",
   
]


const checkBoxesCerner = [
    "All",
    "Patient",
    "CarePlan",
    "AllergyIntolerance",
    "Device",
    "Goal",
    "Encounter",
    "Procedure",
    "Condition",
    "Immunization",
    "MedicationRequest",
    "CareTeam",
    "DiagnosticReport",
    "Observation",
    "DocumentReference",
    "Organization",
    "Location",
    "Practitioner",
    "Provenance"
]


const checkBoxesEcw = [
    "All",
    "Device",
    "Goal",
    "Location",
    "Organization",
    "Practitioner",
    "CarePlan",
    "AllergyIntolerance",
    "Immunization",
    "CareTeam",
    "Encounter",
    "Procedure",
    "PractitionerRole",
    "Medication",
    "DocumentReference",
    "Patient",
    "Condition",
    "MedicationRequest",
    "Binary",
    "Observation",
    "Provenance"
]

const dateMap = [
    {
        label: "No Time Filter(include everything)",
        value: ""
    },
    {
        label: "Within last 3 days",
        value: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
        label: "Within last 1 week",
        value: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
        label: "Within last 2 weeks",
        value: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
        label: "Within last 1 month",
        value: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
        label: "Within last 1 year",
        value: new Date(Date.now() - 1 * 365 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
        label: "Within last 2 years",
        value: new Date(Date.now() - 2 * 365 * 24 * 60 * 60 * 1000).toISOString()
    }
]

const filterListEpic = [
    'MedicationRequest?category=discharge',
    'Condition?code=J45.40 (Asthama)',
    'Condition?code=160050 (Arm Injury)',
]

const filterListCerner = [
    'Condition?category=encounter-diagnosis',
    'Encounter?status=finished',
]

export const groupLists = {
  epic: [
    {
      value: "e3iabhmS8rsueyz7vaimuiaSmfGvi.QwjVXJANlPOgR83",
      label: "Group A - (e3iabhmS8rsueyz7vaimuiaSmfGvi.QwjVXJANlPOgR83)",
    },
  ],
  cerner: [
    {
      value: "11ec-d16a-c763b73e-98e8-a31715e6a2bf",
      label: "Group A - 11ec-d16a-c763b73e-98e8-a31715e6a2bf",
    },
    {
      value: "11ec-d16a-b40370f8-9d31-577f11a339c5",
      label: "Group B - 11ec-d16a-b40370f8-9d31-577f11a339c5",
    },
  ],
  ecw: [
    {
      value: "76acf47f-fed2-4d6b-8917-85fc5e981931",
      label: "Group A - 76acf47f-fed2-4d6b-8917-85fc5e981931",
    },
  ],
  nextgen: [
    {
      value: "52ade5ef-4fd4-466c-9e99-f49ab14dc779",
      label: "Group A - 52ade5ef-4fd4-466c-9e99-f49ab14dc779",
    },
  ],
};

export { 
    groupA, 
    groupB, 
    checkBoxesEpic, 
    checkBoxesCerner, 
    checkBoxesNextgen,
    checkBoxesEcw,
    filterListEpic,
    filterListCerner,
    dateMap 
}